import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { NgModule } from '@angular/core';
import { SelectAvatarPage } from './select-avatar.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule
  ],
  declarations: [SelectAvatarPage],
  exports: [SelectAvatarPage],
  entryComponents : [SelectAvatarPage]
})
export class SelectAvatarPageModule {}
